document.addEventListener('DOMContentLoaded', function () {

  /* ---- scroll reveal ---- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: .12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* ---- mobile nav toggle ---- */
  var navToggle = document.querySelector('.nav-toggle');
  var navLinks = document.querySelector('.nav-links');
  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function () {
      navLinks.classList.toggle('open');
      var expanded = navLinks.classList.contains('open');
      navToggle.setAttribute('aria-expanded', expanded);
    });
  }

  /* ---- product gallery thumbnails ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-main-media]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.dataset.fullSrc || thumb.src;
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  /* ---- quantity steppers ---- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---- variant picker: maps option button selections to a real variant id ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // price/compare-price now live in the buy-box card, outside the <form> itself —
    // scope the lookup to the whole buy-box so they're still found.
    var scope = form.closest('.buy-box') || form.parentElement || document;

    var optionGroups = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[data-variant-id-input]');
    var priceEl = scope.querySelector('[data-price-display]');
    var comparePriceEl = scope.querySelector('[data-compare-price-display]');
    var saveBadge = scope.querySelector('[data-save-badge]');
    var addBtn = form.querySelector('[data-add-to-cart-btn]');
    var stockMsg = form.querySelector('[data-stock-msg]');

    function money(cents) {
      return '£' + (cents / 100).toFixed(2);
    }

    function currentSelection() {
      var sel = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.opt-btn.selected');
        sel.push(active ? active.dataset.value : null);
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === sel[i]; });
      });
    }

    function updateUI() {
      var sel = currentSelection();
      var match = findVariant(sel);
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (comparePriceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          comparePriceEl.textContent = money(match.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (saveBadge) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          saveBadge.textContent = 'Save ' + money(match.compare_at_price - match.price);
          saveBadge.style.display = '';
        } else {
          saveBadge.style.display = 'none';
        }
      }
      if (addBtn) addBtn.disabled = !match.available;
      if (stockMsg) {
        if (!match.available) {
          stockMsg.textContent = 'Currently out of stock';
          stockMsg.classList.add('sold-out');
        } else {
          stockMsg.textContent = 'In stock, ready to send';
          stockMsg.classList.remove('sold-out');
        }
      }
      // disable option buttons that would lead to no combination
      optionGroups.forEach(function (group, gi) {
        group.querySelectorAll('.opt-btn').forEach(function (btn) {
          var testSel = sel.slice();
          testSel[gi] = btn.dataset.value;
          var possible = variants.some(function (v) {
            return v.options.every(function (val, i) { return testSel[i] === null || val === testSel[i]; });
          });
          btn.disabled = !possible;
        });
      });
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.opt-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.opt-btn').forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          updateUI();
        });
      });
    });

    updateUI();
  });

});
